(function(){
  var P = window.__PRODUCT; if(!P) return;
  var ci = P.colorIndex, si = P.sizeIndex;
  function opt(v, idx){ return idx>0 ? v['option'+idx] : null; }
  function money(c){ return (c/100).toLocaleString('fr-FR',{minimumFractionDigits:2,maximumFractionDigits:2})+' €'; }
  function baseName(u){ if(!u) return ''; return u.split('?')[0].replace(/_\d+x\d+/,'').split('/').pop().toLowerCase(); }

  var swWrap=document.getElementById('swatches'),
      szWrap=document.getElementById('sizes'),
      colorName=document.getElementById('colorName'),
      priceEl=document.getElementById('pPrice'),
      btnPrice=document.getElementById('btnPrice'),
      addBtn=document.getElementById('addCart'),
      variantId=document.getElementById('variantId'),
      stock=document.getElementById('stock'),
      bbAdd=document.getElementById('bbAdd'),
      bbPrice=document.getElementById('bbPrice');

  // ---- Carousel ----
  var track=document.getElementById('carTrack'),
      prevBtn=document.getElementById('carPrev'),
      nextBtn=document.getElementById('carNext'),
      dotsWrap=document.getElementById('carDots'),
      slides = track ? [].slice.call(track.querySelectorAll('.slide')) : [],
      cur_i = 0;

  function go(i){
    if(!slides.length) return;
    cur_i = (i + slides.length) % slides.length;
    track.style.transform = 'translateX(' + (-cur_i*100) + '%)';
    if(dotsWrap){ [].forEach.call(dotsWrap.children, function(d,k){ d.classList.toggle('active', k===cur_i); }); }
  }
  if(dotsWrap && slides.length){
    slides.forEach(function(s,k){
      var d=document.createElement('button');
      d.type='button'; d.className='car-dot'+(k===0?' active':'');
      d.setAttribute('aria-label','Voir l\'image '+(k+1));
      d.addEventListener('click', function(){ go(k); });
      dotsWrap.appendChild(d);
    });
  }
  if(slides.length<=1){
    if(prevBtn) prevBtn.style.display='none';
    if(nextBtn) nextBtn.style.display='none';
    if(dotsWrap) dotsWrap.style.display='none';
  }
  if(prevBtn) prevBtn.addEventListener('click', function(){ go(cur_i-1); });
  if(nextBtn) nextBtn.addEventListener('click', function(){ go(cur_i+1); });
  // swipe (mobile)
  if(track){
    var x0=null;
    track.addEventListener('touchstart', function(e){ x0=e.touches[0].clientX; }, {passive:true});
    track.addEventListener('touchend', function(e){
      if(x0===null) return;
      var dx=e.changedTouches[0].clientX - x0;
      if(Math.abs(dx)>40){ go(cur_i + (dx<0?1:-1)); }
      x0=null;
    });
  }
  function setMainImage(src){
    if(!src || !slides.length) return;
    var bn=baseName(src);
    for(var i=0;i<slides.length;i++){
      var im=slides[i].querySelector('img');
      if(im && baseName(im.src)===bn){ go(i); return; }
    }
    // no matching slide: swap the current slide's image
    var im0=slides[cur_i].querySelector('img');
    if(im0) im0.src=src.replace(/width=\d+/,'width=900');
  }

  // ---- Colour helpers ----
  function colorHex(name){
    var n=name.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'');
    var map=[['bleu roi','#2b3cb5'],['bleu ciel','#a9c4d8'],['rouille','#b0532e'],['bleu clair','#7fa6c7'],['bleu marine','#2a3a55'],['bleu','#3d5a76'],['marine','#2a3a55'],['jean clair','#7b9fc4'],['jean','#3f5f82'],['gris clair','#bcb6ac'],['gris','#9a938a'],['noire','#2a2a2a'],['noir','#2a2a2a'],['blanc','#efe9df'],['beige','#d9cdb6'],['camel','#b08d57'],['verte','#3d5a3d'],['vert','#3d5a3d'],['rose','#c98d8d'],['marron','#6b4a2f'],['safran','#d19a3a'],['kaki','#6b6b3d'],['bordeaux','#6b2a35'],['orange','#c8632a'],['turquoise','#3a9aa0'],['rouge','#a83232'],['leopard','#b58a55'],['corail','#e0846a'],['fourrure','#c9b79c'],['taupe','#a39585']];
    for(var i=0;i<map.length;i++){ if(n.indexOf(map[i][0])>-1) return map[i][1]; }
    return null;
  }
  function nrm(s){ return (s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,''); }
  function mediaSrcs(){ return (P.media||[]).map(function(m){ return (m.preview_image && m.preview_image.src) || m.src || ''; }).filter(Boolean); }
  function imgForColorName(name){
    var syn={noir:'black',noire:'black',blanc:'white',vert:'green',verte:'green',gris:'grey',grise:'grey',bleu:'blue',rouge:'red',rose:'pink',marron:'brown'};
    var toks=nrm(name).split(/[^a-z0-9]+/).filter(function(w){return w.length>2 && ['velours','cotele','coton','laine','clair','fonce'].indexOf(w)<0;});
    var imgs=mediaSrcs(), best=null, bs=0;
    imgs.forEach(function(u){ var f=nrm(u), sc=0; toks.forEach(function(t){ if(f.indexOf(t)>-1||(syn[t]&&f.indexOf(syn[t])>-1)) sc++; }); if(sc>bs){bs=sc;best=u;} });
    return bs>0?best:null;
  }
  // sample the dominant fabric colour from a product photo
  // (favour saturated pixels so patterns/prints read vivid, not muddy)
  function sampleColor(url, cb){
    var img=new Image();
    img.crossOrigin='anonymous';
    img.onload=function(){
      try{
        var s=48, c=document.createElement('canvas'); c.width=s; c.height=s;
        var ctx=c.getContext('2d');
        var w=img.naturalWidth, h=img.naturalHeight;
        ctx.drawImage(img, w*0.22, h*0.22, w*0.56, h*0.56, 0, 0, s, s);
        var d=ctx.getImageData(0,0,s,s).data;
        var r=0,g=0,b=0,n=0, cr=0,cg=0,cb2=0,cn=0;
        for(var i=0;i<d.length;i+=4){
          var R=d[i], G=d[i+1], B=d[i+2], A=d[i+3];
          if(A<125) continue;
          r+=R; g+=G; b+=B; n++;
          var mx=Math.max(R,G,B), mn=Math.min(R,G,B);
          var sat = mx===0 ? 0 : (mx-mn)/mx;
          if(sat>0.16 && mx>45 && mx<248){ cr+=R; cg+=G; cb2+=B; cn++; }
        }
        if(!n){ cb(null); return; }
        var uR, uG, uB;
        if(cn > n*0.10){ uR=cr/cn; uG=cg/cn; uB=cb2/cn; }   // enough coloured pixels: use them
        else { uR=r/n; uG=g/n; uB=b/n; }                    // neutral product (beige/grey): plain average
        cb('rgb('+Math.round(uR)+','+Math.round(uG)+','+Math.round(uB)+')');
      }catch(e){ cb(null); }
    };
    img.onerror=function(){ cb(null); };
    img.src=url.replace(/width=\d+/,'width=260');
  }

  var selColor = colorName ? colorName.textContent.trim() : null;
  var selSize = szWrap ? (szWrap.querySelector('.size.active')||{}).textContent : null;

  function variantFor(color, size){
    for(var i=0;i<P.variants.length;i++){ var v=P.variants[i];
      var okC = ci>0 ? (opt(v,ci)===color) : true;
      var okS = si>0 ? (opt(v,si)===size) : true;
      if(okC && okS) return v;
    }
    return null;
  }
  function firstOfColor(color){
    for(var i=0;i<P.variants.length;i++){ if(ci===0 || opt(P.variants[i],ci)===color) return P.variants[i]; }
    return null;
  }

  function withWidth(u,w){ if(!u) return u; return u + (u.indexOf('?')>-1?'&':'?') + 'width=' + w; }
  // a name is a plain solid colour only if every word is a colour/shade word
  var SOLID_WORDS=['bleu','bleue','marine','clair','claire','fonce','foncee','gris','grise','anthracite','noir','noire','blanc','blanche','beige','camel','vert','verte','rose','rosee','marron','safran','kaki','bordeaux','orange','turquoise','rouge','jean','denim','chine','chinee','ecru','creme','cream','taupe','moutarde','prune','corail','fourrure','uni','unie'];
  function isSolidName(name){
    var toks=nrm(name).split(/[^a-z0-9]+/).filter(Boolean);
    if(!toks.length) return false;
    return toks.every(function(t){ return SOLID_WORDS.indexOf(t)>-1; });
  }
  // paint swatches: plain solid colour -> flat hex; anything patterned/printed -> show the real fabric
  if(swWrap){
    // if most colours of this product are shown as photos, show every colour as a photo (consistent row)
    var swAll=swWrap.querySelectorAll('.swatch'), nSolid=0;
    swAll.forEach(function(s){ if(isSolidName(s.getAttribute('data-color'))) nSolid++; });
    var allPhotos = nSolid*2 < swAll.length;
    swAll.forEach(function(s){
      var name=s.getAttribute('data-color');
      var fv=allPhotos && firstOfColor(name);
      if(isSolidName(name) && !(fv && fv.featured_image)){
        var hex=colorHex(name);
        if(hex){ s.style.background=hex; return; }
      }
      // patterned / printed colour: show a close crop of the actual fabric in the round
      var v=firstOfColor(name);
      var u=(v && v.featured_image && v.featured_image.src) || imgForColorName(name) || '';
      if(u){
        s.style.backgroundColor='#eee7db';
        s.style.backgroundImage='url("'+withWidth(u,200)+'")';
        s.style.backgroundSize='cover';
        s.style.backgroundPosition='center 42%';
        s.style.backgroundRepeat='no-repeat';
      } else {
        s.style.background='#c9c2b6';
        var u2=mediaSrcs()[0];
        if(u2) sampleColor(u2, function(rgb){ if(rgb) s.style.background=rgb; });
      }
    });
  }

  // ---- Disponibilité par coloris / par taille ----
  var sizeHelp=document.getElementById('sizeHelp'),
      notifyBox=document.getElementById('notifyBox');

  function sizesOf(color){
    var out=[];
    szWrap && szWrap.querySelectorAll('.size').forEach(function(b){
      var s=b.getAttribute('data-size'), v=variantFor(color, s);
      if(v && v.available) out.push(s);
    });
    return out;
  }
  function colorsWithSize(size){
    if(!swWrap) return [];
    var out=[];
    swWrap.querySelectorAll('.swatch').forEach(function(s){
      var c=s.getAttribute('data-color'), v=variantFor(c, size);
      if(v && v.available) out.push(c);
    });
    return out;
  }
  function selectColor(color){
    if(!swWrap) return;
    var target=null;
    swWrap.querySelectorAll('.swatch').forEach(function(s){ if(s.getAttribute('data-color')===color) target=s; });
    if(target) target.click();
  }

  function openNotify(size){
    if(!notifyBox) return;
    notifyBox.hidden=false;
    var t=document.getElementById('notifyTitle');
    var c=document.getElementById('notifyColor'), z=document.getElementById('notifySize'), bd=document.getElementById('notifyBody');
    if(c) c.value = selColor || '';
    if(z) z.value = size || selSize || '';
    if(bd) bd.value = 'Demande de réassort — ' + (P.title||'') + ' / ' + (selColor||'-') + ' / ' + (size||selSize||'-');
    if(t) t.textContent = size ? ('Prévenez-moi quand la taille ' + size + ' revient') : 'Prévenez-moi quand c\'est de nouveau disponible';
    var em=document.getElementById('notifyEmail'); if(em) em.focus({preventScroll:true});
    notifyBox.scrollIntoView({block:'nearest', behavior:'smooth'});
  }

  // panneau d'aide : quand la taille voulue n'est plus dispo dans ce coloris
  function showSizeHelp(size){
    if(!sizeHelp) return;
    var others=colorsWithSize(size).filter(function(c){ return c!==selColor; });
    if(others.length){
      var html='<p>La taille <b>'+size+'</b> n\'est plus disponible en <b>'+selColor+'</b>, mais elle l\'est ici :</p><div class="sh-swatches"></div>';
      sizeHelp.innerHTML=html;
      var row=sizeHelp.querySelector('.sh-swatches');
      others.slice(0,8).forEach(function(c){
        var src=null;
        swWrap && swWrap.querySelectorAll('.swatch').forEach(function(s){ if(s.getAttribute('data-color')===c) src=s; });
        var b=document.createElement('button');
        b.type='button'; b.className='sh-sw'; b.title=c; b.setAttribute('aria-label',c);
        if(src){ b.style.cssText=src.style.cssText; }
        b.addEventListener('click', function(){ selectColor(c); var t=szWrap.querySelector('.size[data-size="'+size+'"]'); if(t && !t.classList.contains('unavailable')) t.click(); });
        row.appendChild(b);
      });
      var names=document.createElement('p');
      names.className='sh-names';
      names.textContent=others.slice(0,8).join(' · ');
      sizeHelp.appendChild(names);
    } else {
      sizeHelp.innerHTML='<p>La taille <b>'+size+'</b> est épuisée dans tous les coloris.</p>'+
        '<button type="button" class="sh-notify">Prévenez-moi quand elle revient</button>';
      sizeHelp.querySelector('.sh-notify').addEventListener('click', function(){ openNotify(size); });
    }
    sizeHelp.hidden=false;
  }

  function refreshSizes(){
    if(!szWrap) return;
    szWrap.querySelectorAll('.size').forEach(function(b){
      var size=b.getAttribute('data-size');
      var v=variantFor(selColor, size);
      var ok = v && v.available;
      b.classList.toggle('unavailable', !ok);
      // on garde le bouton cliquable pour proposer une alternative au lieu d'un cul-de-sac
      b.disabled = false;
      b.setAttribute('aria-disabled', ok ? 'false' : 'true');
      if(!ok) b.classList.remove('active');
    });
    if(szWrap.querySelector('.size.active')==null){
      var firstOk=szWrap.querySelector('.size:not(.unavailable)');
      if(firstOk){ firstOk.classList.add('active'); selSize=firstOk.getAttribute('data-size'); }
      else selSize=null;
    }
    if(sizeHelp){ sizeHelp.hidden=true; sizeHelp.innerHTML=''; }
    // message quand il ne reste qu'une taille (ou aucune) dans ce coloris
    var avail=sizesOf(selColor);
    var note=document.getElementById('sizeNote');
    if(!note && szWrap.parentNode){
      note=document.createElement('p'); note.id='sizeNote'; note.className='size-note';
      szWrap.parentNode.insertBefore(note, szWrap.nextSibling);
    }
    if(note){
      if(avail.length===0){
        note.innerHTML='Ce coloris est épuisé. <button type="button" class="sn-link" id="snNotify">Prévenez-moi</button>';
        note.hidden=false;
        var sn=document.getElementById('snNotify'); if(sn) sn.addEventListener('click', function(){ openNotify(null); });
      } else if(avail.length===1 && szWrap.querySelectorAll('.size').length>1){
        note.textContent='Il ne reste que la taille '+avail[0]+' dans ce coloris.';
        note.hidden=false;
      } else { note.hidden=true; note.textContent=''; }
    }
  }

  function updateSelection(){
    var v = variantFor(selColor, selSize);
    if(v){
      variantId.value=v.id;
      priceEl.textContent=money(v.price);
      if(btnPrice) btnPrice.textContent=money(v.price);
      if(bbPrice) bbPrice.textContent=money(v.price);
      if(v.available){
        addBtn.disabled=false; addBtn.childNodes[0].nodeValue='Ajouter au panier — ';
        if(bbAdd){ bbAdd.disabled=false; bbAdd.textContent='Ajouter au panier'; }
        if(stock){ stock.innerHTML='✓ <b>En stock</b> · expédié sous 48h'; }
      } else {
        addBtn.disabled=true; addBtn.childNodes[0].nodeValue='Rupture — ';
        if(bbAdd){ bbAdd.disabled=true; bbAdd.textContent='Rupture'; }
        if(stock){
          stock.innerHTML='Temporairement épuisé — <button type="button" class="sn-link" id="stNotify">prévenez-moi quand il revient</button>';
          var st=document.getElementById('stNotify');
          if(st) st.addEventListener('click', function(){ openNotify(selSize); });
        }
      }
    } else {
      addBtn.disabled=true; addBtn.childNodes[0].nodeValue='Indisponible — ';
      if(bbAdd){ bbAdd.disabled=true; bbAdd.textContent='Indisponible'; }
      if(stock){
        stock.innerHTML='Temporairement épuisé — <button type="button" class="sn-link" id="stNotify2">prévenez-moi quand il revient</button>';
        var st2=document.getElementById('stNotify2');
        if(st2) st2.addEventListener('click', function(){ openNotify(selSize); });
      }
    }
  }

  if(swWrap){
    swWrap.querySelectorAll('.swatch').forEach(function(s){
      s.addEventListener('click', function(){
        swWrap.querySelectorAll('.swatch').forEach(function(x){x.classList.remove('active');});
        s.classList.add('active');
        selColor=s.getAttribute('data-color');
        if(colorName) colorName.textContent=selColor;
        var fv=firstOfColor(selColor);
        if(fv && fv.featured_image){ setMainImage(fv.featured_image.src); }
        else { var mi=imgForColorName(selColor); if(mi) setMainImage(mi); }
        refreshSizes();
        updateSelection();
      });
    });
  }
  if(szWrap){
    szWrap.querySelectorAll('.size').forEach(function(b){
      b.addEventListener('click', function(){
        var size=b.getAttribute('data-size');
        if(b.classList.contains('unavailable')){ showSizeHelp(size); return; }
        szWrap.querySelectorAll('.size').forEach(function(x){x.classList.remove('active');});
        b.classList.add('active');
        selSize=size;
        if(sizeHelp){ sizeHelp.hidden=true; }
        updateSelection();
      });
    });
  }

  // size guide toggle
  var sgBtn=document.getElementById('sizeGuideBtn'), sg=document.getElementById('sizeGuide');
  if(sgBtn && sg){ sgBtn.addEventListener('click', function(){ sg.hidden=!sg.hidden; }); }

  // sticky mobile buy bar -> triggers the real add-to-cart
  if(bbAdd){
    document.body.classList.add('has-buybar');
    bbAdd.addEventListener('click', function(){ if(addBtn && !addBtn.disabled) addBtn.click(); });
  }

  // ---- Coloris affiché par défaut : celui qui a le plus de tailles en stock ----
  // (sauf si le visiteur arrive sur un variant précis via ?variant=)
  if(swWrap && szWrap && !/[?&]variant=/.test(location.search)){
    var best=null, bestN=sizesOf(selColor).length;
    swWrap.querySelectorAll('.swatch').forEach(function(s){
      var c=s.getAttribute('data-color'), n=sizesOf(c).length;
      if(n>bestN){ bestN=n; best=c; }
    });
    if(best) selectColor(best);
  }

  // retour du formulaire de réassort : on rouvre le bloc avec le message de confirmation
  if(/contact_posted=true/.test(location.search) && notifyBox){
    notifyBox.hidden=false;
    notifyBox.scrollIntoView({block:'center'});
  }

  refreshSizes();
  updateSelection();
})();
